import { USER_CONSTANTS } from "@/modules/User/constants/UserConstants";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "ImgAvatar"
})
export default class ImgAvatar extends Vue {
  @Prop() src!: string;
  @Prop() alt!: string;

  imageAvatarError = false;

  get imageAvatarUser() {
    return this.imageAvatarError ? USER_CONSTANTS.DEFAULT_IMG : this.src;
  }

  async mounted() {
    this.imageAvatarError = false;
  }
}
